import { createClient } from '@supabase/supabase-js'

// Environment variables with hardcoded fallbacks
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://kkxclqbrjnloxedyeasj.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtreGNscWJyam5sb3hlZHllYXNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk0MjQ0MDQsImV4cCI6MjA2NTAwMDQwNH0.64ZbCw0l6jApK4mSaaeH7gMM-I8B8HSTaOpcChYpxs0'

// Validate inputs before creating client
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration')
}

// Create Supabase client - v2.39.0 (stable, working version)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

// Test import disabled to prevent automatic test user creation
// if (import.meta.env.DEV) {
//   import('./test-supabase')
// }

// Export types for TypeScript
export type { User, Session, AuthError } from '@supabase/supabase-js'